import { useQuery } from "react-query";
import { useApiService } from "../useApiService";
import { QUERY } from "../../constants/query";
import { ColorControllerService } from "../../services";

// Hook to get all colors
export const useGetAllColors = () => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.GET_ALL_COLORS];

  const query = useQuery(queryKey, () =>
    handleRequest(ColorControllerService.colorControllerGetAllColors())
  );

  return {
    ...query,
  };
};
